<template>
    <div class="course-overview">
        <section class="course-overview course-overview__infobox">
            <div v-html="contactText"></div>
        </section>
        <section
            class="course-overview course-overview__section"
            v-for="category in categories"
            :key="category"
        >
            <div class="course-overview course-overview__category-title">
                {{ category }}
            </div>
            <div class="course-overview course-overview__category">
                <div
                    class="course-overview course-overview__course"
                    v-for="course in courses.filter(
                        course => course.category == category
                    )"
                    :key="course.id"
                >
                    <div class="course-overview course-overview__heading">
                        {{ course.title }}
                    </div>
                    <div class="course-overview course-overview__row">
                        <img
                            class="course-overview course-overview__image"
                            :src="course.image_path"
                        />
                        <div
                            class="course-overview course-overview__texts"
                            v-html="course.contents"
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: ['courses', 'contactText'],

    data() {
        return {
            categories: ['Arbeitsschutz', 'Compliance'],
        };
    },
};
</script>
